import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import { FaEdit, FaPlus } from 'react-icons/fa';
import { MdCheckCircle, MdRemoveCircle } from 'react-icons/md';

import { getLeaderboardsByAdmin } from './queries';
import { activeLeaderboard } from './mutations';
import { Dialog } from '../../../components';
import FilterFromToV2 from '../../../components/Filter/FilterFromToV2';
import styles from './styles';
import { colors } from '../../../constants';

const ACTIVE_OPTIONS = [
  { value: '', label: 'All' },
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
];

const formatListDate = (value) => {
  if (!value) return '-';
  const parsed = moment(value, ['MM/DD/YYYY HH:mm:ss', 'MM/DD/YYYY HH:mm', 'MM/DD/YYYY'], true);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY HH:mm') : value;
};

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: colors.parimary,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class TableLeaderboards extends Component {
  state = {
    name: '',
    active: '',
    page: 1,
    limit: 15,
    open: false,
    titleDialog: '',
    content: '',
    confirmActivateOpen: false,
    activateId: null,
    activating: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const filterKeys = [
      'page', 'limit', 'name', 'active',
    ];
    const changed = filterKeys.some((key) => prevState[key] !== this.state[key]);
    if (changed) {
      this.refetchData();
    }
  }

  buildFiltersInput = () => {
    const { name, active } = this.state;
    return {
      name: name || null,
      active: active === '' ? null : Number(active),
    };
  };

  refetchData = () => {
    const { refetch } = this.props;
    if (!refetch) return;
    const { page, limit } = this.state;
    refetch({
      input: {
        ...this.buildFiltersInput(),
        page: page || 1,
        limit: limit || 15,
      },
    });
  };

  handleFilterChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value, page: 1 });
  };

  handleChangePage = (event, page) => {
    this.setState({ page: page + 1 });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ limit: event.target.value, page: 1 });
  };

  openActivateConfirm = (id) => {
    this.setState({ confirmActivateOpen: true, activateId: id });
  };

  closeActivateConfirm = () => {
    this.setState({ confirmActivateOpen: false, activateId: null });
  };

  onActivate = async () => {
    const { activateId } = this.state;
    const { activeLeaderboard: activateMutation } = this.props;
    if (!activateId) return;

    this.setState({ activating: true });
    try {
      await activateMutation({
        variables: { input: { id: activateId } },
        refetchQueries: [{ query: getLeaderboardsByAdmin, variables: { input: { page: 1, limit: 15 } } }],
      });
      this.setState({
        activating: false,
        confirmActivateOpen: false,
        activateId: null,
        open: true,
        titleDialog: 'Activate Leaderboard',
        content: 'Leaderboard activated successfully.',
      });
      this.refetchData();
    } catch (error) {
      const message = error && error.graphQLErrors && error.graphQLErrors[0]
        ? error.graphQLErrors[0].message
        : 'Activation failed';
      this.setState({
        activating: false,
        confirmActivateOpen: false,
        activateId: null,
        open: true,
        titleDialog: 'Activate Leaderboard',
        content: message,
      });
    }
  };

  renderFilters = () => (
    <div className={this.props.classes.filterRow}>
      <FilterFromToV2
        label="Name"
        fromField={(
          <TextField
            name="name"
            value={this.state.name}
            onChange={this.handleFilterChange}
            placeholder="Name"
          />
        )}
        resetFn={() => this.setState({ name: '', page: 1 })}
        smallButton
      />
      <FormControl className={this.props.classes.statusSelect}>
        <InputLabel shrink>Active</InputLabel>
        <Select
          name="active"
          value={this.state.active}
          onChange={this.handleFilterChange}
          displayEmpty
        >
          {ACTIVE_OPTIONS.map((option) => (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );

  render() {
    const { classes, leaderboardsData, loading } = this.props;
    const {
      page, limit, open, titleDialog, content,
      confirmActivateOpen, activating,
    } = this.state;

    if (loading && !leaderboardsData) return null;

    const leaderboards = (leaderboardsData && leaderboardsData.leaderboards) || [];
    const countRows = (leaderboardsData && leaderboardsData.count_rows) || 0;

    return (
      <div>
        <Dialog
          title={titleDialog}
          content={content}
          open={open}
          onOk={() => this.setState({ open: false })}
        />
        <Dialog
          title="Activate Leaderboard"
          content="This will deactivate the current active leaderboard and activate this one. Continue?"
          open={confirmActivateOpen}
          onOk={this.onActivate}
          onCancel={this.closeActivateConfirm}
          cancelText="Cancel"
        />
        <div className={classes.searchWrapper}>
          <Link to="/addLeaderboard">
            <Button variant="contained" color="primary" className={classes.button}>
              <Typography component="p" className={classes.text}>Add</Typography>
              <FaPlus color="#ffffff" size={14} />
            </Button>
          </Link>
          <Typography component="p" style={{ fontSize: '14px' }}>
            Rows: {countRows}
          </Typography>
        </div>
        {this.renderFilters()}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <CustomTableCell>Name</CustomTableCell>
                <CustomTableCell align="right">Period From (ET)</CustomTableCell>
                <CustomTableCell align="right">Period To (ET)</CustomTableCell>
                <CustomTableCell align="center">Active</CustomTableCell>
                <CustomTableCell align="center">Actions</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leaderboards.map((row) => (
                <TableRow className={classes.row} key={row.id}>
                  <CustomTableCell component="th" scope="row">
                    {row.name}
                  </CustomTableCell>
                  <CustomTableCell align="right">{formatListDate(row.periodFrom)}</CustomTableCell>
                  <CustomTableCell align="right">{formatListDate(row.periodTo)}</CustomTableCell>
                  <CustomTableCell align="center">
                    {row.active === 1
                      ? <MdCheckCircle color={colors.dark} size={16} />
                      : <MdRemoveCircle color={colors.red} size={16} />}
                  </CustomTableCell>
                  <CustomTableCell align="center">
                    <div className={classes.actionsCell}>
                      <Link to={{ pathname: `/detailLeaderboard/${row.id}` }}>
                        <Button variant="contained" color="primary" className={classes.button}>
                          <Typography component="p" className={classes.text}>Edit</Typography>
                          <FaEdit color="#ffffff" size={14} />
                        </Button>
                      </Link>
                      {row.active !== 1 && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          onClick={() => this.openActivateConfirm(row.id)}
                          disabled={activating}
                        >
                          <Typography component="p" className={classes.text}>Activate</Typography>
                        </Button>
                      )}
                    </div>
                  </CustomTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[15, 25, 50]}
            component="div"
            count={countRows}
            rowsPerPage={limit}
            page={page - 1}
            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  }
}

TableLeaderboards.defaultProps = {
  classes: {},
  leaderboardsData: null,
  loading: false,
  refetch: () => {},
  activeLeaderboard: () => {},
};

TableLeaderboards.propTypes = {
  classes: PropTypes.object,
  leaderboardsData: PropTypes.object,
  loading: PropTypes.bool,
  refetch: PropTypes.func,
  activeLeaderboard: PropTypes.func,
};

const LeaderboardsQuery = graphql(getLeaderboardsByAdmin, {
  options: () => ({
    variables: {
      input: {
        page: 1,
        limit: 15,
        name: null,
        active: null,
      },
    },
    fetchPolicy: 'network-only',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    leaderboardsData: data.getLeaderboardsByAdmin,
    refetch: data.refetch,
  }),
});

const ActivateLeaderboard = graphql(activeLeaderboard, { name: 'activeLeaderboard' });

export default withStyles(styles)(compose(LeaderboardsQuery, ActivateLeaderboard)(TableLeaderboards));
